// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../imgs/blob-warm-duo-2x.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wjFj0y08gOEWtm73ALR0 {
  background-color: transparent;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  height: 100vh;
  border: none;
  padding: var(--space-m-5xl) var(--space-s-5xl);
}

.NozEgDNq0wD0ygr8VRho {
  background-image: linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.4),
      rgba(255, 255, 255, 0.4)
    ),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position-x: center, calc(-1 * var(--space-3xl));
  background-position-y: center, 10%;
  background-size:
    cover,
    auto 70%;
  background-repeat: no-repeat;
  border-radius: var(--space-xl);
  background-color: var(--white-color);
  justify-content: center;
  display: flex;
  flex-direction: column;
  max-width: 40rem;
  min-height: 50rem;
  max-height: 50rem;
  height: 90vh;
  align-items: stretch;
  padding-left: 3rem;
  padding-right: 3rem;
}

.ppwJFGTNqQrbRDGossVX {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--step-2);
  color: var(--white-color);
  background: none;
  background-color: transparent;
  border: none;
  border-radius: 0;
  opacity: 0.6;
  mix-blend-mode: hard-light;
  cursor: pointer;
  z-index: 100;
}

.mRap7nXsJz8nk0UAFqcd {
  width: 100%;
  margin-left: 1rem;
  justify-content: right;
  display: flex;
}

.wjFj0y08gOEWtm73ALR0 {
  animation: C6qI4b9TndYZ0DQpxE69 0.7s ease-out forwards; /* Animation for fade-in */
  transition:
    visibility 0s 0.7s,
    opacity 0.7s linear; /* Transitions for fade-out */
  opacity: 1;
  visibility: visible;
}

.wjFj0y08gOEWtm73ALR0[hidden] {
  visibility: hidden;
  opacity: 0;
  animation: O3s0v1QMRYjTn_gbur3A 0.5s ease-out forwards; /* Apply fade-out when modal is hidden */
}

.wjFj0y08gOEWtm73ALR0[open]::backdrop {
  background-color: rgba(var(--primary-color-rgb), 0.9);
  backdrop-filter: blur(16px);
  transition:
    opacity 0.7s ease-out,
    visibility 0s 0.7s;
}

.wjFj0y08gOEWtm73ALR0::backdrop {
  visibility: visible;
  opacity: 1;
}

.wjFj0y08gOEWtm73ALR0[hidden]::backdrop {
  visibility: hidden;
  opacity: 0;
}

.gmnHZuPKGfOPxKDxbVFr {
  font-size: var(--step-2);
}

.gmnHZuPKGfOPxKDxbVFr h2 {
  text-align: left;
  color: var(--primary-color);
  font-weight: 700;
  line-height: 1.5;
  margin-top: 0;
  margin-bottom: 2.5em;
}

.gmnHZuPKGfOPxKDxbVFr p {
  font-size: var(--step-0);
  line-height: var(--base-line-height);
  margin-top: 0;
  margin-bottom: 1.5em;
}

.YIoPeBCktzLXK5e13WJH {
  font-size: var(--step-1);
  --input-border-color: black;
  --input-width: 90%;
  --input-padding-tb: var(--space-s);
  --input-padding-rl: var(--space-s);
  --input-border-width: 5px;
}

.etlSxU6IB1ZDgbBP7OkQ {
  font-size: var(--step-1);
  --input-width: 90%;
  --input-padding-tb: var(--space-s);
  --input-padding-rl: var(--space-s);
  --input-border-width: 5px;
}

.pI6v7AaMD0K792az7Aae {
  padding-top: 3rem;
}

._CEop0JEc8XXVNjqC6ep {
  font-size: var(--step-0);
  padding-bottom: 2rem;
  padding-top: 1rem;
}

@media only screen and (max-width: 600px) {
  .gmnHZuPKGfOPxKDxbVFr {
    font-size: var(--step-0);
  }

  .ppwJFGTNqQrbRDGossVX {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: var(--step-2);
    color: var(--black-color);
    background: none;
    background-color: transparent;
    border: none;
    border-radius: 0;
    opacity: 1;
    mix-blend-mode: hard-light;
    cursor: pointer;
    z-index: 100;

    margin-right: 1rem;
  }

  .mRap7nXsJz8nk0UAFqcd {
    background-color: var(--grey-color);
    width: 100%;
    margin-left: 0rem;
    justify-content: right;
    padding-top: 1rem;
    padding-bottom: 1rem;
    display: flex;
  }

  .wjFj0y08gOEWtm73ALR0 {
    padding: 0 0;
    background-color: var(--white-color);
    width: 100%;
    height: max-content;
    border: none;
  }

  .NozEgDNq0wD0ygr8VRho {
    max-height: none;
    width: 100%;
    align-items: stretch;
    padding: 0rem;
  }
}

@keyframes C6qI4b9TndYZ0DQpxE69 {
  from {
    transform: translateY(10%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes O3s0v1QMRYjTn_gbur3A {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/widgets/dialogs/SubscribeDialog.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE;;;;;2CAKwC;EACxC,0DAA0D;EAC1D,kCAAkC;EAClC;;YAEU;EACV,4BAA4B;EAC5B,8BAA8B;EAC9B,oCAAoC;EACpC,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,sDAAwC,EAAE,0BAA0B;EACpE;;uBAEqB,EAAE,6BAA6B;EACpD,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sDAAyC,EAAE,wCAAwC;AACrF;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B;;sBAEoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;EAClC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,kCAAkC;EAClC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;IACxB,yBAAyB;IACzB,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,0BAA0B;IAC1B,eAAe;IACf,YAAY;;IAEZ,kBAAkB;EACpB;;EAEA;IACE,mCAAmC;IACnC,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,oCAAoC;IACpC,WAAW;IACX,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,oBAAoB;IACpB,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".modal {\n  background-color: transparent;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  max-width: 100%;\n  height: 100vh;\n  border: none;\n  padding: var(--space-m-5xl) var(--space-s-5xl);\n}\n\n.modalContent {\n  background-image: linear-gradient(\n      45deg,\n      rgba(255, 255, 255, 0.4),\n      rgba(255, 255, 255, 0.4)\n    ),\n    url(\"../../imgs/blob-warm-duo-2x.png\");\n  background-position-x: center, calc(-1 * var(--space-3xl));\n  background-position-y: center, 10%;\n  background-size:\n    cover,\n    auto 70%;\n  background-repeat: no-repeat;\n  border-radius: var(--space-xl);\n  background-color: var(--white-color);\n  justify-content: center;\n  display: flex;\n  flex-direction: column;\n  max-width: 40rem;\n  min-height: 50rem;\n  max-height: 50rem;\n  height: 90vh;\n  align-items: stretch;\n  padding-left: 3rem;\n  padding-right: 3rem;\n}\n\n.modalCloseBtn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: var(--step-2);\n  color: var(--white-color);\n  background: none;\n  background-color: transparent;\n  border: none;\n  border-radius: 0;\n  opacity: 0.6;\n  mix-blend-mode: hard-light;\n  cursor: pointer;\n  z-index: 100;\n}\n\n.modalCloseBtnWrapper {\n  width: 100%;\n  margin-left: 1rem;\n  justify-content: right;\n  display: flex;\n}\n\n.modal {\n  animation: fadeIn 0.7s ease-out forwards; /* Animation for fade-in */\n  transition:\n    visibility 0s 0.7s,\n    opacity 0.7s linear; /* Transitions for fade-out */\n  opacity: 1;\n  visibility: visible;\n}\n\n.modal[hidden] {\n  visibility: hidden;\n  opacity: 0;\n  animation: fadeOut 0.5s ease-out forwards; /* Apply fade-out when modal is hidden */\n}\n\n.modal[open]::backdrop {\n  background-color: rgba(var(--primary-color-rgb), 0.9);\n  backdrop-filter: blur(16px);\n  transition:\n    opacity 0.7s ease-out,\n    visibility 0s 0.7s;\n}\n\n.modal::backdrop {\n  visibility: visible;\n  opacity: 1;\n}\n\n.modal[hidden]::backdrop {\n  visibility: hidden;\n  opacity: 0;\n}\n\n.signUpScroll {\n  font-size: var(--step-2);\n}\n\n.signUpScroll h2 {\n  text-align: left;\n  color: var(--primary-color);\n  font-weight: 700;\n  line-height: 1.5;\n  margin-top: 0;\n  margin-bottom: 2.5em;\n}\n\n.signUpScroll p {\n  font-size: var(--step-0);\n  line-height: var(--base-line-height);\n  margin-top: 0;\n  margin-bottom: 1.5em;\n}\n\n.emailInput {\n  font-size: var(--step-1);\n  --input-border-color: black;\n  --input-width: 90%;\n  --input-padding-tb: var(--space-s);\n  --input-padding-rl: var(--space-s);\n  --input-border-width: 5px;\n}\n\n.zipInput {\n  font-size: var(--step-1);\n  --input-width: 90%;\n  --input-padding-tb: var(--space-s);\n  --input-padding-rl: var(--space-s);\n  --input-border-width: 5px;\n}\n\n.btnGroup {\n  padding-top: 3rem;\n}\n\n.errorMessage {\n  font-size: var(--step-0);\n  padding-bottom: 2rem;\n  padding-top: 1rem;\n}\n\n@media only screen and (max-width: 600px) {\n  .signUpScroll {\n    font-size: var(--step-0);\n  }\n\n  .modalCloseBtn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: var(--step-2);\n    color: var(--black-color);\n    background: none;\n    background-color: transparent;\n    border: none;\n    border-radius: 0;\n    opacity: 1;\n    mix-blend-mode: hard-light;\n    cursor: pointer;\n    z-index: 100;\n\n    margin-right: 1rem;\n  }\n\n  .modalCloseBtnWrapper {\n    background-color: var(--grey-color);\n    width: 100%;\n    margin-left: 0rem;\n    justify-content: right;\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n    display: flex;\n  }\n\n  .modal {\n    padding: 0 0;\n    background-color: var(--white-color);\n    width: 100%;\n    height: max-content;\n    border: none;\n  }\n\n  .modalContent {\n    max-height: none;\n    width: 100%;\n    align-items: stretch;\n    padding: 0rem;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    transform: translateY(10%);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `wjFj0y08gOEWtm73ALR0`,
	"modalContent": `NozEgDNq0wD0ygr8VRho`,
	"modalCloseBtn": `ppwJFGTNqQrbRDGossVX`,
	"modalCloseBtnWrapper": `mRap7nXsJz8nk0UAFqcd`,
	"fadeIn": `C6qI4b9TndYZ0DQpxE69`,
	"fadeOut": `O3s0v1QMRYjTn_gbur3A`,
	"signUpScroll": `gmnHZuPKGfOPxKDxbVFr`,
	"emailInput": `YIoPeBCktzLXK5e13WJH`,
	"zipInput": `etlSxU6IB1ZDgbBP7OkQ`,
	"btnGroup": `pI6v7AaMD0K792az7Aae`,
	"errorMessage": `_CEop0JEc8XXVNjqC6ep`
};
export default ___CSS_LOADER_EXPORT___;
